import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './PhotoBooth.css';

const PhotoBooth = () => {
  return (
    <div className="photo-booth-page">
      <PageBanner
        title="Photo Booth"
        image={productionRouteBanners['photo-booth']}
        imageAlt={productionRouteBannerAlts['photo-booth']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Photo Booth Services</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Fun and interactive photo booth experiences for your guests
            </p>
          </div>
          
          <div className="about-content">
            <p>
              Add excitement to your event with our professional photo booth services. 
              Complete with props, instant prints, and digital sharing options, 
              your guests will love capturing fun moments throughout the celebration.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PhotoBooth;
